import { Component, ElementRef, inject, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AppHelper } from '@app/core/app.helper';
import { FuiButtonComponent, FuiTextInputComponent } from '@fui/fui-components';
import { PopupContentComponent } from '@components/popup-content/popup-content.component';
import { DynamicFieldsModule } from '@app/modules/dynamic-fields/dynamic-fields.module';
import { ValidationErrorService } from '@services/validation/validation-error.service';
import { IRenameData } from '@app/modules/table/children/table-column-action/interfaces/table-column-action.interface';
import { TableColumnActionService } from '@app/modules/table/children/table-column-action/table-column-action.service';
import { IMainLang } from '@interfaces/languages/main-lang';
import { LANG_DICTIONARY_TOKEN } from '@constants/diConstant';

@Component({
    selector: 'app-table-rename-column',
    templateUrl: './table-rename-column.component.html',
    styleUrls: ['./table-rename-column.component.scss'],
    standalone: true,
    imports: [
        FuiButtonComponent,
        PopupContentComponent,
        ReactiveFormsModule,
        DynamicFieldsModule,
        FuiTextInputComponent,
    ],
    providers: [ValidationErrorService],
})
export class TableRenameColumnComponent implements OnChanges {
    private fb: FormBuilder = inject(FormBuilder);
    readonly dictionary: IMainLang = inject(LANG_DICTIONARY_TOKEN);
    readonly validationErrorService = inject(ValidationErrorService);
    readonly #tableColumnActionService = inject(TableColumnActionService);

    /** Форма */
    form: FormGroup = this.fb.group({
        titleColumn: ['', [Validators.required]],
    });

    /** Ссылка на объект формы */
    @ViewChild('formRef', { static: true }) formRef: ElementRef;

    /** Компонент поповера */
    @ViewChild(PopupContentComponent) popupContentComponent: PopupContentComponent;

    @Input() data: IRenameData;

    ngOnChanges() {
        this.form.get('titleColumn').setValue(this.data?.titleColumn ?? '');
    }

    /**
     * Сохранение данных
     */
    save() {
        if (this.form.valid) {
            let newTitle = this.form.value.titleColumn;

            switch (typeof newTitle) {
                case 'string':
                    newTitle = newTitle.trim();
                    break;
            }
            this.#tableColumnActionService.eventNewColumnName$.next({
                title: newTitle,
                name: this.data.nameColumn,
            });
            this.close();
        } else {
            AppHelper.validateAllFormFields(this.form);
            const target = this.formRef.nativeElement.querySelector(
                '.mat-select.ng-invalid, .mat-input-element.ng-invalid, .mat-checkbox-input.ng-invalid',
            );
            setTimeout(() => {
                if (target.querySelector('input')) {
                    target.querySelector('input').focus();
                }
            }, 0);
        }
    }

    /** Отобразить popupContent компонента */
    show(x: number, y: number) {
        this.popupContentComponent.show(x, y);
    }

    /** Скрыть контент */
    close() {
        this.popupContentComponent.hide();
    }
}
